// extracted by mini-css-extract-plugin
export default {"wrapper":"YeAG9yh3"};